import React            from 'react';

class Container extends React.Component {
    constructor(props) {
        super(props);
        this.state = { };
    }

    render(){
        let { value, children, className } = this.props;
        return(
            <div 
                className       = { className } 
                data-value      = { value }
            >
                { children }
            </div>
        )
    }
}

export default Container;